import { get } from 'util/fetch';
import { login } from '../../config/backendRoutes';

export const fetchUserInfo = async token => get(`${login}/users/me`, { token });
